import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ThankYou.css'; // Import the CSS file

const ThankYou = () => {
  return (
    <div className="thank-you-container">
      <h1 className="thank-you-title">
        We’ll get started on your FREE Growth Audit!
      </h1>
      <h2 className="thank-you-subtitle">We’ll Be In Contact Soon!</h2>
      <Link to="/" className="home-button-link">
        <button className="back-home-button">Back To Home</button>
      </Link>
    </div>
  );
};

export default ThankYou;
